import React from 'react';
import { colors } from 'themes/components';
import styled from 'styled-components';

const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  background: ${(
    props
  ) => `linear-gradient(to right, ${props.bg1}, ${props.bg2}) padding-box,
    linear-gradient(to bottom right, ${props.border1}, ${props.border2}) border-box`};
  color: ${colors.grey90};
  border: 1px solid transparent;
  border-radius: 32px;
  padding: 6px 12px 7px 12px;
  margin-bottom: 16px;
  & > svg {
    margin-right: 8px;
  }
`;

const Eyebrow = (props) => <Wrapper {...props}>{props.children}</Wrapper>;

export default Eyebrow;
